import { pad } from "./pad.js";

const MONTHS_SHORT = "janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.".split("_");
const WEEKDAYS_SHORT = "dim._lun._mar._mer._jeu._ven._sam.".split("_");

export function formatDate(date, format = "dd/MM/yyyy") {
  if (!date) {
    return "";
  }

  date = "" + date;

  const d = new Date(
    date.match(/^[0-9]{4}-[0-9]{2}-[0-9]{2} [0-9]{2}:[0-9]{2}:[0-9]{2}/)
      ? date.replace(" ", "T")
      : date.indexOf("T") > -1
      ? date
      : date + "T00:00:00"
  );

  return format
    .replace("yyyy", d.getFullYear())
    .replace("MMM", MONTHS_SHORT[d.getMonth()])
    .replace("MM", pad(d.getMonth() + 1))
    .replace("dd", pad(d.getDate()))
    .replace("DDD", WEEKDAYS_SHORT[d.getDay()])
    .replace("DD", pad(d.getDay()))
    .replace("hh", pad(d.getHours()))
    .replace("mm", pad(d.getMinutes()))
    .replace("sss", pad(d.getMilliseconds()))
    .replace("ss", pad(d.getSeconds()));
}

export function formatDuration(ms) {
  if (!ms) {
    return "0s";
  }

  let result = "";

  const millis = ms % 1000;
  ms = Math.floor(ms / 1000);
  if (millis > 0) {
    result = "." + pad(millis, 3);
  }
  const s = ms % 60;
  ms = Math.floor(ms / 60);
  result = (ms > 0 ? pad(s, 2) : s) + result;
  if (ms > 0) {
    const m = ms % 60;
    ms = Math.floor(ms / 60);
    result = (ms > 0 ? pad(m, 2) : m) + ":" + result;
    if (ms > 0) {
      result = ms + ":" + result;
    }
  }

  return result.replace(/0+$/, "");
}
